import React from "react";

export const AboutComann = () => {
  return (
    <section id="about" data-testid="about-section" className="px-6 md:px-12 py-16 md:py-24 relative z-10 border-t border-[#2a2a2a]">
      <div className="max-w-6xl mx-auto grid md:grid-cols-[minmax(0,420px)_1fr] gap-10 md:gap-14 items-center">
        {/* Photo */}
        <div className="relative">
          <div className="absolute -inset-3 rounded-3xl bg-[#e2ff31]/10 blur-2xl" aria-hidden="true" />
          <div className="relative overflow-hidden rounded-3xl border border-[#2a2a2a] bg-[#0a0a0a]">
            <img
              data-testid="about-photo"
              src="/about-comann.webp"
              alt="CO MANN — creator, artist, producer"
              className="w-full h-full object-cover aspect-[3/4]"
              loading="lazy"
            />
          </div>
        </div>

        {/* Bio */}
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-mono uppercase tracking-widest text-[#e2ff31] mb-6">
            About the founder
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl tracking-tighter font-bold leading-[1.05]">
            CO <span className="text-[#e2ff31]">MANN</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#9ca3af] leading-relaxed">
            CO MANN is a creator, artist, producer, songwriter, and the owner of the CO MANN Brand,
            bringing over a decade of experience in crafting original music and innovative sound. Known
            for blending sharp production with authentic storytelling, CO MANN has built a reputation for
            high-quality beats, professional artistry, and forward-thinking music business leadership.
            Through CO MANN Beats, he delivers industry-ready instrumentals, creative direction, and a
            full spectrum of production services designed for artists who want to elevate their sound and
            build lasting impact.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            {["Producer", "Artist", "Songwriter", "Creative Direction"].map((t) => (
              <span key={t} className="text-xs font-mono uppercase tracking-widest text-[#f3f4f6] border border-[#2a2a2a] rounded-full px-4 py-2">
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
